import axios from 'axios'
import { request } from '@/utils/AxiosRequest'

export async function getHsptlList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getHsptlList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&hsptlType=${data.type}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getSchlList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getSchlList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&schoolSeCd=${data.type}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getPuborderList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPuborderList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getFirefightingList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getFirefightingList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getPubofficeList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPubofficeList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getBusstonList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getBusstonList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getExpresswayList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getExpresswayList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getPrkplaceList(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPrkplaceList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

export async function getRuralTourism(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPrteFarmTurmMbrList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}
export async function getRuralLodging(data: any) {
  return request.get(`/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getPrteFarmStyiMbrList.do?neLat=${data.neLat}&neLng=${data.neLng}&seLat=${data.seLat}&seLng=${data.seLng}&apiKey=${window.SystemConfig.facilityApiKey}`)
}

// https://apis.data.go.kr/B553077/api/open/sdsc2/storeListInRadius?ServiceKey=yetLmSS4iKrtfVQXUo6KI%2B1H40jwrov8F8YPCuHt9%2B0vVjT6im8zq%2B3LT6ggcQIWK8BiK4SjrkMjqqNClGbpFg%3D%3D&pageNo=1&numOfRows=1000&radius=2000&cx=126.90594575872178&cy=35.97957207784259&indsLclsCd=I2&type=json

// export async function getLodgingIndustry(params: any) {
//   let getUrl = '/nddt/portal/apis-api/B553077/api/open/sdsc2/storeListInRadius?'
//   Object.entries(params).forEach(([key, value]) => {
//     getUrl += `${key}=${value}&`
//   })
//   if (getUrl.endsWith('&')) {
//     getUrl = getUrl.slice(0, -1)
//   }
//   return request.get(getUrl)
// }

export async function sendLodgingIndustry(params: { [key: string]: any }) {
  const baseUrl = 'https://apis.data.go.kr/B553077/api/open/sdsc2/storeListInRadius'
  const logIngestUrl = '/nddt/portal/apis-api'

  const requestData = {
    urltype: '',
    method: 'GET',
    header: { 'Content-Type': 'application/json' },
    body: '',
    url: `${baseUrl}?${new URLSearchParams(params as Record<string, string>).toString()}`,
  }

  try {
    const response = await axios.post(logIngestUrl, requestData)
    // Add any response handling here
    console.log(response.data)
    return response.data
  }
  catch (error) {
    // Error handling
    console.error(error)
    throw error
  }
}

export async function getLodgingIndustry(params: { [s: string]: unknown } | ArrayLike<unknown>) {
  const baseUrl = 'https://apis.data.go.kr/B553077/api/open/sdsc2/storeListInRadius'

  // Use type assertion to specify the shape of params
  const urlParams = params as { ServiceKey: string; pageNo: string; numOfRows: string; radius: string; cx: string; cy: string; indsLclsCd: string; type: string }

  // sendRequestToLogIngest function call with modified parameters
  await sendLodgingIndustry(urlParams)

  // Original data request code
  return request.get(`${baseUrl}?${new URLSearchParams(params as Record<string, string>).toString()}`)
}

// export async function getRestaurant(params: any) {
//   let getUrl = '/nddt/portal/B553077/api/open/sdsc2/storeListInRadius?'
//   Object.entries(params).forEach(([key, value]) => {
//     getUrl += `${key}=${value}&`
//   })
//   if (getUrl.endsWith('&')) {
//     getUrl = getUrl.slice(0, -1)
//   }
//   return request.get(getUrl)
// }

export async function sendRestaurant(params: { [key: string]: any }) {
  const baseUrl = 'https://apis.data.go.kr/B553077/api/open/sdsc2/storeListInRadius'
  const logIngestUrl = '/nddt/portal/apis-api'

  const requestData = {
    urltype: '',
    method: 'GET',
    header: { 'Content-Type': 'application/json' },
    body: '',
    url: `${baseUrl}?${new URLSearchParams(params as Record<string, string>).toString()}`,
  }

  try {
    const response = await axios.post(logIngestUrl, requestData)
    // Add any response handling here
    console.log(response.data)
    return response.data
  }
  catch (error) {
    // Error handling
    console.error(error)
    throw error
  }
}

export async function getRestaurant(params: { [s: string]: unknown } | ArrayLike<unknown>) {
  const baseUrl = 'https://apis.data.go.kr/B553077/api/open/sdsc2/storeListInRadius'

  // Use type assertion to specify the shape of params
  const urlParams = params as { ServiceKey: string; pageNo: string; numOfRows: string; radius: string; cx: string; cy: string; indsLclsCd: string; type: string }

  // sendRequestToLogIngest function call with modified parameters
  await sendRestaurant(urlParams)

  // Original data request code
  return request.get(`${baseUrl}?${new URLSearchParams(params as Record<string, string>).toString()}`)
}

export async function getTraditionalMarket(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/extn/getMrktList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}
